<template>
  <div class="film-header-root">
  <header>
    <a class="brand" href="#" aria-label="返回首页" @click.prevent="$emit('navigate', 'home')">
      <i class="brand-logo"></i>
      <span>
        <b>蝴蝶影视平台</b>
        <small>BUTTERFLY PICTURES</small>
      </span>
    </a>
    <nav aria-label="主导航">
      <button
        type="button"
        :class="{ active: activePage === 'home' }"
        @click="$emit('navigate', 'home')"
      >
        {{ t("nav_home") }}
      </button>
      <button
        type="button"
        :class="{ active: activePage === 'rules' }"
        @click="$emit('navigate', 'rules')"
      >
        {{ t("nav_rules") }}
      </button>
      <button
        type="button"
        :class="{ active: activePage === 'dashboard' }"
        @click="$emit('navigate', 'dashboard')"
      >
        {{ t("nav_dash") }}
      </button>
    </nav>
    <div class="header-actions">
      <span class="network">{{ networkLabel }}</span>
      <select
        class="lang-switch"
        aria-label="选择语言"
        :value="lang"
        @change="onLangChange"
      >
        <option v-for="item in langs" :key="item.code" :value="item.code">
          {{ item.name }}
        </option>
      </select>
      <button type="button" class="btn small" @click="onWalletClick">
        {{ walletButtonLabel }}
      </button>
    </div>
  </header>
  <FilmWalletModals
    :show-picker="showWalletModal"
    :show-disconnect="showDisconnectModal"
    :wallets="wallets"
    :address="currentWallet && currentWallet.address"
    :pick-title="t('wallet_title')"
    :pick-sub="walletPickSub"
    :not-installed="walletNotInstalled"
    :connected-title="t('wallet_title')"
    :disconnect-label="disconnectLabel"
    @close-picker="showWalletModal = false"
    @close-disconnect="showDisconnectModal = false"
    @select-wallet="onWalletSelect"
    @disconnect="disconnect"
  />
  </div>
</template>

<script>
import { walletManager } from "@/utils/walletManager";
import {
  createWalletOptionsForUi,
  findInstalledProvider,
  WALLET_OPTIONS,
} from "@/utils/walletCatalog";
import { isChainId } from "@/contract";
import { LANGS } from "@/film/i18n";
import { shortenAddress } from "@/film/format";
import FilmWalletModals from "./FilmWalletModals.vue";

export default {
  name: "FilmHeader",
  components: { FilmWalletModals },
  props: {
    t: { type: Function, required: true },
    lang: { type: String, required: true },
    activePage: { type: String, required: true },
  },
  data() {
    return {
      langs: LANGS,
      wallets: createWalletOptionsForUi(),
      currentWallet: null,
      showWalletModal: false,
      showDisconnectModal: false,
      disconnectLabel: "断开连接",
      walletPickSub: "选择已安装的钱包以连接 BSC 主网",
      walletNotInstalled: "未检测到",
    };
  },
  computed: {
    networkLabel() {
      if (!this.currentWallet) return this.t("network");
      return isChainId ? this.t("network") : "Wrong network";
    },
    walletButtonLabel() {
      if (this.currentWallet && this.currentWallet.address) {
        return `◈ ${shortenAddress(this.currentWallet.address)}`;
      }
      return this.t("wallet_btn");
    },
  },
  async created() {
    window.addEventListener("walletManager:providersChanged", this.updateWalletList);
    this.updateWalletList();
    await walletManager.checkIfConnected();
    this.currentWallet = walletManager.currentWallet;
    this.updateWalletList();
  },
  beforeDestroy() {
    window.removeEventListener("walletManager:providersChanged", this.updateWalletList);
  },
  methods: {
    onLangChange(e) {
      this.$emit("change-lang", e.target.value);
    },
    updateWalletList() {
      const availableWallets = Array.from(walletManager.providers.values());
      this.wallets.forEach((wallet) => {
        const catalogEntry = WALLET_OPTIONS.find(
          (entry) => entry.catalogId === wallet.catalogId
        );
        if (!catalogEntry) return;
        const matched = findInstalledProvider(catalogEntry, availableWallets);
        if (matched) {
          wallet.info = {
            ...wallet.info,
            ...matched.info,
            icon: wallet.info.icon || matched.info.icon,
          };
        } else {
          const { uuid, ...rest } = wallet.info;
          wallet.info = { ...rest };
          delete wallet.info.uuid;
        }
      });
    },
    onWalletClick() {
      if (this.currentWallet) {
        this.showDisconnectModal = true;
        return;
      }
      this.showWalletModal = true;
    },
    onWalletSelect(wallet) {
      if (!wallet.info.uuid) return;
      this.connect(wallet.info.uuid);
    },
    async connect(uuid) {
      try {
        this.currentWallet = await this.$wallet.connectWallet(uuid);
        this.showWalletModal = false;
        this.$emit("wallet-connected");
      } catch (error) {
        this.$emit("wallet-error", error);
      }
    },
    disconnect() {
      if (!this.currentWallet) return;
      this.$wallet.disconnectWallet(this.currentWallet.uuid);
      this.currentWallet = null;
      this.showDisconnectModal = false;
      this.$emit("wallet-disconnected");
    },
    requireWallet() {
      if (this.currentWallet) return true;
      this.showWalletModal = true;
      return false;
    },
  },
};
</script>
